export const frontmatter = {
    "draft": false,
    "title": "Flujos de trabajo",
    "description": "Gestión completa de workflows en OnnIA: equipos, proyectos, editor visual, componentes, variables, credenciales, playground y ejecuciones.",
    "sidebar_label": "Descripción general",
    "sidebar_group": "referencia",
    "sidebar_order": 1
}

export const toc = [
    {
        "depth": 2,
        "id": "acceso-al-modulo",
        "value": "Acceso al módulo"
    },
    {
        "depth": 2,
        "id": "jerarquia-equipo-proyecto-workflow",
        "value": "Jerarquía: Equipo → Proyecto → Workflow"
    },
    {
        "depth": 2,
        "id": "gestion-de-equipos",
        "value": "Gestión de equipos"
    },
    {
        "depth": 3,
        "id": "crear-un-equipo",
        "value": "Crear un equipo"
    },
    {
        "depth": 3,
        "id": "perfil-del-equipo",
        "value": "Perfil del equipo"
    },
    {
        "depth": 2,
        "id": "gestion-de-proyectos",
        "value": "Gestión de proyectos"
    },
    {
        "depth": 2,
        "id": "gestion-de-workflows",
        "value": "Gestión de workflows"
    },
    {
        "depth": 2,
        "id": "editor-de-workflows",
        "value": "Editor de workflows"
    },
    {
        "depth": 2,
        "id": "componentes-disponibles",
        "value": "Componentes disponibles"
    },
    {
        "depth": 2,
        "id": "variables-y-secretos",
        "value": "Variables y secretos"
    },
    {
        "depth": 3,
        "id": "alcance",
        "value": "Alcance"
    },
    {
        "depth": 3,
        "id": "variables",
        "value": "Variables"
    },
    {
        "depth": 3,
        "id": "secretos",
        "value": "Secretos"
    },
    {
        "depth": 2,
        "id": "credenciales",
        "value": "Credenciales"
    },
    {
        "depth": 2,
        "id": "mcps",
        "value": "MCPs"
    }
]